import { Link } from "react-router-dom";
// import Menu from "../assets/menu.svg";
import Nav from "../components/Nav";
import Logo from "../assets/logo.svg";
import Cd from "../assets/swirls.svg";
import Stick from "../assets/stick.svg";
import Arrow from "../assets/arrow.svg";
import ScrollRotate from "./ScrollToRotate";
// import { ScrollRotate } from "react-scroll-rotate";

import "./Home.scss";

const Home = () => {
  return (
    <div id="HomePage">
      <Nav />
      <section className="LogoContainer">
        <Link to="/">
          <img
            className="Logo animated animatedFadeInUp fadeInUp"
            src={Logo}
            alt="Eleven-a Logo"
          />
        </Link>
        <span className="SubHeading animated animatedFadeInUp fadeInUp">
          an independent record label
        </span>
      </section>

      <section className="CDContainer animated animatedFadeInUp fadeInUp">
        <div className="cdGroup">
          <img className="stick" src={Stick} alt="Cd Spiral" />

          <ScrollRotate>
            <img src={Cd} alt="Cd Spiral" />
          </ScrollRotate>
        </div>

        <p>
          Eleven-A is a{" "}
          <span className="highlightedText">
            privately held Dallas based publisher
          </span>{" "}
          that invests exclusively in music copyrights. At Eleven-A, we believe
          songs are a new asset class.
        </p>
      </section>

      {/* <section className="arrowContainer"></section> */}

      <footer>
        <img className="downArrow" src={Arrow} alt="Down Arrow" />
        <section className="contactContainer">
          <Link to="/contact">
            <span>contact us</span>
          </Link>
          <ul>
            <li>Eleven-A</li>
            <li>
              <span className="square">■</span> 1920 McKinney Ave, Floor 7
            </li>
            <li>
              <span className="square">■</span> Dallas, TX 75201
            </li>
          </ul>
        </section>
        <ul className="eleven-a">
          <li>Eleven-A</li>
          <li>
            <span className="square">■</span> 1920 McKinney Ave, Floor 7
          </li>
          <li>
            <span className="square">■</span> Dallas, TX 75201
          </li>
        </ul>
      </footer>
    </div>
  );
};

export default Home;
